const getWishlists = state => state.wishlists;

const isLoading = state => getWishlists(state).loading;
const getData = state => getWishlists(state).data || {};
const getWishlistEntries = state => getData(state).wishlists || [];
const getWishlistEntriesWithProduct = (state, productCode) =>
    getWishlistEntries(state).filter(entry =>
        entry.some(product => product.code === productCode),
    ) || [];

export default {
    isLoading,
    getData,
    getWishlistEntries,
    getWishlistEntriesWithProduct,
};
